/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

function getColumnWidths(em) {
  const { parentSize } = em || '';

  if (em?.suffix) {
    switch(parentSize) {
      case 'full':
        return [2, 8, 2];
  
      case 'large':
        return [4, 6, 2];
  
      default:
        return [5, 5, 2];
    }
  }

  switch(parentSize) {
    case 'full':
      return [2, 10];

    case 'large':
      return [4, 8];

    default:
      return [5, 7];
  }
}

export function TextInput(props) {
  const { app, em, data } = props;
  const handlers = app && app.handlers ? app.handlers : {};
  const { parentSize } = em || '';
  const floating = (em && em.floating) || false;

  const [label_width, input_width, suffix_width] = getColumnWidths(em);

  const groupClass = (floating ? '' : 'row') + ' ' + (em && em.class ? em.class : '');
  const labelClass = floating ? 'label mb-1' : `col-sm-${label_width} col-form-label`;
  const suffixClass = `col-sm-${suffix_width || 2}`;
  let inputClass = floating ? '' : `col-sm-${input_width}`;
  if (!em?.label && !em?.suffix) inputClass = `col`;
  // if (em?.suffix) {
  //   inputClass = floating ? 'col-sm-10' : `col-sm-${parentSize === 'full' ? '8' : '5'}`;
  // }
  if (em?.size) inputClass += ` form-control-${em.size}`;
  inputClass += em && em.align ? ` text-${em.align}` : '';

  const handleDefaultChange = useCallback((e) => {
    console.warn('No change handler', e.target);
  }, []);

  const inputProperty = {};
  if (props.data && em && em.field) {
    const _keys = em.field.split('.');
    if (_keys.length > 1) {
      inputProperty.value = (props.data && em && em.field && props.data[_keys[0]][_keys[1]]) || '';
    } else {
      inputProperty.value = (props.data && em && em.field && props.data[em.field]) || '';
    }

    inputProperty.onChange = handleDefaultChange;
  }

  if (em?.placeholder) {
    inputProperty.placeholder = em.placeholder;
  }

  if (props.onChange) {
    inputProperty.onChange = props.onChange;
  }

  if (props.onBlur) {
    inputProperty.onBlur = props.onBlur;
  }

  if (em.onChange && handlers[em.onChange]) {
    inputProperty.onChange = handlers[em.onChange];
  }

  if (em.onBlur && handlers[em.onBlur]) {
    inputProperty.onBlur = handlers[em.onBlur];
  }

  return (
    <div className={`form-group ${groupClass}`}>
      {em && em.label && <label className={`${labelClass}`}>{em && em.label}</label>}
      <input id={em?.id}
        type={em?.password ? 'password' : 'text'}
        className={`form-control ${inputClass}`}
        name={(em && em.field) || em?.name}
        placeholder={em && em.placeholder}
        onKeyDown={em && em.onKeyDown}
        readOnly={em && em.readOnly}
        autoComplete="off"
        list={(em && em.datalist) || props.datalist}
        {...inputProperty}
      />
      {em && em.suffix && <label className={`${suffixClass}`}>{em && em.suffix}</label>}
    </div>
  );
}

TextInput.propTypes = {
  app : PropTypes.any, 
  em : PropTypes.any, 
  data : PropTypes.any, 
  onChange : PropTypes.func,
  onBlur : PropTypes.func,
  children : PropTypes.any,
  datalist : PropTypes.any,
}